import * as SelectDropdownParts from "./index.parts";

export namespace SelectDropdown {
	export type ElementName = SelectDropdownParts.Root.ElementName;
	export type ElementType = SelectDropdownParts.Root.ElementType;
	export type Props = Omit<SelectDropdownParts.Root.Props, "children">;
}

export const SelectDropdown = (props: SelectDropdown.Props) => {
	return <SelectDropdownParts.Root {...props} />;
};
